import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import HttpService from '../services/HttpServices';
const apiService = HttpService;

// Initial state of the slice
const initialState = {
  partnerProfileData: [], // List of partner profile for the landing page
  partnerProfileDetailsById: {}, // Details of a single partner profile
  partnerProfileCertificateData : [],
  companyType: [],
  loading: false,
  error: null,
};

// Async thunk for partner profiles for the landing page
export const fetchPartnerProfileData = createAsyncThunk(
  'partnerProfile/fetchPartnerProfileData',
  async (queryParams, thunkAPI) => {
    try {
      const response = await apiService.get('/companies',
        { params: queryParams },
      );
      return response.data
    } catch (error) {
      console.log("error : ", error)
      return thunkAPI.rejectWithValue(error.response.data || error.message);
    }
  }
);

export const fetchPartnerProfileCertificateDetails = createAsyncThunk(
  'partnerProfile/fetchPartnerProfileCertificateDetails',
  async ({ companyId, queryParams }, thunkAPI) => { 
    try {
      const response = await apiService.get(`/companies/${companyId}`,
        { params: queryParams });
      return response;
    } catch (error) {
      console.log("error : ", error);
      return thunkAPI.rejectWithValue(error.response.data || error.message);
    }
  }
);

// Async thunk for fetching an partner profile by ID
export const fetchPartnerProfileById = createAsyncThunk(
  'partnerProfile/fetchPartnerProfileById',
  async (url, { rejectWithValue }) => {
    try {
      const response = await apiService.get(url);
      return response.data; 
    } catch (error) {
      console.error("Failed to fetch Business Unit details:", error.message);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

export const getCompanyType = createAsyncThunk(
  'partnerProfile/getCompanyType',
  async (queryParams, { rejectWithValue }) => {
    try {
      const response = await apiService.get('/companies',
        { params: queryParams },
      );
      return response.data; 
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

export const partnerProfileSlice = createSlice({
  name: 'partnerProfile',
  initialState,
  reducers: {
    resetPartnerProfileState: (state) => {
      state.partnerProfileData = [];
      state.partnerProfileCertificateData = [];
      state.paginationInfo = {};
      state.partnerProfileDetailsById = {};
      state.companyType = [];
      state.loading = false;
      state.error = null;
      state.companyName = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // Handling fetch partner profiles
      .addCase(fetchPartnerProfileData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPartnerProfileData.fulfilled, (state, action) => {
        state.loading = false;
        state.partnerProfileData = action.payload.data;
        state.paginationInfo = {
          totalRecords: action.payload.totalRecords,
        };
      })
      .addCase(fetchPartnerProfileData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; 
      })
      // Handling fetch partner proifle By Id
      .addCase(fetchPartnerProfileById.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPartnerProfileById.fulfilled, (state, action) => {
        state.loading = false;
        state.partnerProfileDetailsById = action.payload.data[0];
      })
      .addCase(fetchPartnerProfileById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchPartnerProfileCertificateDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPartnerProfileCertificateDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.partnerProfileCertificateData = action.payload.data.data;
      })
      .addCase(fetchPartnerProfileCertificateDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getCompanyType.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getCompanyType.fulfilled, (state, action) => {
        state.status = 'succeeded';
        // state.token = action.payload;
        state.companyType = action.payload.data;
        state.error = null;
      })
      .addCase(getCompanyType.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
  },
});

// Export actions and reducer
export const { resetPartnerProfileState } = partnerProfileSlice.actions;
export default partnerProfileSlice.reducer;
